import { Box } from '@cp/ds/src/components/box';
import { SxProps } from '@mui/material';
import React from 'react';

export const Circle: React.FC<{ sx?: SxProps }> = (props) => {
  const { sx } = props;
  return <Box sx={{ border: '2px solid', borderColor: 'white', borderRadius: '50%', position: 'absolute', ...sx }} />;
};
